<template>
    <li @click.prevent="open"
        :class="{
            'ChatContacts__item': true,
            'ChatContacts__item--unread': last_seen_at < last_message.created_at,
            'ChatContacts__item--failed': hasFailed,
            'is-active': isActive
        }"
    >
        <img
            class="ChatContacts__item-avatar"
            :src="avatar"
            :alt="name"/>

        <div class="ChatContacts__item-data">
            <div class="ChatContacts__item-head">
                <h4 class="ChatContacts__item-name truncate">{{name}}</h4>
                <span class="ChatContacts__item-date">{{chatFormatTime(last_message.created_at)}}</span>
            </div>
            <div class="ChatContacts__item-last-message truncate">
                {{
                last_message.content.length > 20
                ? last_message.content.slice(0,20) + '...'
                : last_message.content
                }}
            </div>
        </div>
    </li>
</template>

<script>
    import {getters, mutations} from "../../store";
    import {chatFormatTime} from "../../utils";

    export default {
        props: ['discussion'],
        computed: {
            name: function () {
                return getters.discussionName(this.discussion.id);
            },
            avatar: function () {
                return this.discussion.users
                    .filter(user => user.id !== this.$user.id)
                    .pop().profile.small_avatar;
            },
            isActive: function () {
                return this.discussion.id === getters.openedDiscussionId();
            },
            hasFailed: function () {
                return !!getters.discussionMessages(this.discussion.id).find(message => message.status === 'failed');
            },
            last_message: function () {
                return this.discussion.last_message;
            },
            last_seen_at: function () {
                let userId = getters.user().id;
                return this.discussion.users_reads[userId];
            }
        },
        methods: {
            chatFormatTime,
            open: async function () {
                this.$emit('opening', this.discussion);
                mutations.setOpenedDiscussionId(this.discussion.id);
            }
        }
    }
</script>
